import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store/store';
import { initGlobalErrorReporting } from './api/errorReporter';
import './index.css';

// Install global error reporter — captures uncaught JS errors and unhandled
// promise rejections into the error_queue table for triage.
initGlobalErrorReporting();

// Environment validation - catch wrong-env deployments early
// The app's AUTH_URL should match the hostname pattern
const validateEnvironment = () => {
  const authUrl = import.meta.env.VITE_AUTH_URL || '';
  const currentHost = window.location.hostname;

  // Detect environment mismatch
  const isStaging = currentHost.includes('staging');
  const authIsStaging = authUrl.includes('staging');

  if (isStaging !== authIsStaging) {
    const expected = isStaging ? 'staging' : 'production';
    const got = authIsStaging ? 'staging' : 'production';
    console.error(
      `🚨 ENVIRONMENT MISMATCH: Running on ${expected} but AUTH_URL points to ${got}!\n` +
      `   Current host: ${currentHost}\n` +
      `   AUTH_URL: ${authUrl}\n` +
      `   This is likely a build error. Rebuild with correct BUILD_ENV.`
    );
    // Show visible warning in dev/staging
    if (isStaging) {
      document.body.innerHTML = `
        <div style="padding: 40px; font-family: monospace; background: #fef2f2; min-height: 100vh;">
          <h1 style="color: #991b1b;">⚠️ Environment Mismatch</h1>
          <p>This staging deployment was built with <strong>production</strong> config.</p>
          <p>AUTH_URL: <code>${authUrl}</code></p>
          <p>Expected: <code>https://staging-auth.buynosoftware.com</code></p>
          <hr style="margin: 20px 0;">
          <p>Fix: Rebuild with <code>--build-arg BUILD_ENV=staging</code></p>
        </div>
      `;
      throw new Error('Environment mismatch - stopping app');
    }
  }
};

validateEnvironment();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
